// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"71bca687","845":"dc19a21e"}[chunkId] + ".chunk.js";
};